
<header class="app-header">
@let isAuthenticated = (isAuthenticated$ | async) || false;
@let isAdmin = (isAdmin$ | async) || false;
@let isMaintenanceMode = (isMaintenanceMode$ | async) || false;

  <!-- Banner Manutenzione per Admin -->
  @if (isAdmin && isMaintenanceMode) {
    <div class="maintenance-banner bg-warning text-dark text-center py-2 px-3">
      <i class="fas fa-tools me-2"></i>
      <strong>Manutenzione ON</strong> - Il sito è in modalità manutenzione
    </div>
  }

  <nav class="navbar navbar-expand-lg navbar-light fixed-top" [style.top.px]="isAdmin && isMaintenanceMode ? 40 : 0" style="height: 75px;">
    <div class="container">
      <!-- Logo a sinistra -->
      <a class="navbar-brand d-flex align-items-center" routerLink="/">
        <!-- <i class="fas fa-chart-line me-2 text-black"></i> -->
        <img src="/logo.svg" alt="DOPT" class="logo-img">
        <!-- <span>DOPT</span> -->
      </a>

      <!-- Toggle button per mobile -->
      <button
        class="navbar-toggler"
        type="button"
        (click)="toggleMobileMenu()"
        aria-controls="navbarNav"
        [attr.aria-expanded]="isMobileMenuOpen"
        aria-label="Apri il menu di navigazione">
        <i class="fas fa-bars fa-lg"></i>
      </button>

      <!-- Menu di navigazione -->
      <div class="collapse navbar-collapse transition-all" id="navbarNav" [class.show]="isMobileMenuOpen">
        <!-- Pagine al centro -->
        <ul class="navbar-nav mx-auto">
          <li class="nav-item">
            <a class="nav-link fw-medium p-3 rounded" routerLink="/" (click)="closeMobileMenu()">
              Home
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link fw-medium p-3 rounded" [routerLink]="['/']" fragment="offerta" (click)="closeMobileMenu()">
              Offerta
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link fw-medium p-3 rounded" [routerLink]="['/']" fragment="chi-siamo" (click)="closeMobileMenu()">
              Chi siamo
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link fw-medium p-3 rounded" [routerLink]="['/']" fragment="contatti" (click)="closeMobileMenu()">
              Contatti
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link fw-medium p-3 rounded" routerLink="/blog" (click)="closeMobileMenu()">
              <span class="badge bg-secondary">Blog</span>
            </a>
          </li>

        </ul>

        <!-- Profilo a destra -->
        <ul class="navbar-nav">
          @if (isAuthenticated) {
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle d-flex align-items-center"
                href="#"
                id="navbarDropdown"
                role="button"
                (click)="toggleDropdown(); $event.preventDefault()"
                [attr.aria-expanded]="isDropdownOpen">
                @if (user$ | async; as user) {
                  <div class="profile-avatar rounded-circle d-flex align-items-center justify-content-center small me-2">
                    <i class="fas fa-user"></i>
                  </div>
                  <span>{{ user.name }}</span>
                }
              </a>
              @if (isDropdownOpen) {
                <ul class="dropdown-menu dropdown-menu-end show border-0 shadow rounded-3 py-2 mt-2">
                  @if (user$ | async; as user) {
                    <li>
                      <div class="dropdown-item py-2 px-3 d-flex align-items-center justify-content-between">
                        <span class="fw-medium me-2">
                          <i class="fas fa-crown me-2"></i>
                          Abbonamento
                        </span>
                        <span class="badge" [ngClass]="getSubscriptionBadgeClass(user.subscription)">{{ user.subscription }}</span>
                      </div>
                    </li>
                    <li><hr class="dropdown-divider"></li>
                  }
                  <li>
                    <a class="dropdown-item py-2 px-3 fw-medium" routerLink="/calcolatori" (click)="closeDropdown(); closeMobileMenu()">
                      <i class="fas fa-list-ul me-2"></i>
                      Calcolatori
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item py-2 px-3 fw-medium" routerLink="/market-dashboard" (click)="closeDropdown(); closeMobileMenu()">
                      <i class="fas fa-calendar-alt me-2"></i>
                      Market Dashboard
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item py-2 px-3 fw-medium" routerLink="/post-instagram" (click)="closeDropdown(); closeMobileMenu()">
                      <i class="fab fa-instagram me-2"></i>
                      Post Instagram
                    </a>
                  </li>
                  <li><hr class="dropdown-divider"></li>
                  <li>
                    <a class="dropdown-item py-2 px-3 fw-medium" href="#" (click)="navigateToProfile(); closeMobileMenu(); $event.preventDefault()">
                      <i class="fas fa-user-circle me-2"></i>
                      Profilo
                    </a>
                  </li>
                  @if (isAdmin$ | async) {
                    <li><hr class="dropdown-divider"></li>
                    <li>
                      <a class="dropdown-item py-2 px-3 fw-medium" routerLink="/backoffice" (click)="closeDropdown(); closeMobileMenu()">
                        <i class="fas fa-tachometer-alt me-2"></i>
                        Backoffice
                      </a>
                    </li>
                  }
                  <li><hr class="dropdown-divider"></li>
                  <li>
                    <a class="dropdown-item py-2 px-3 fw-medium text-danger" href="#" (click)="logout(); $event.preventDefault()">
                      <i class="fas fa-sign-out-alt me-2"></i>
                      Logout
                    </a>
                  </li>
                </ul>
              }
            </li>
          } @else {
            <li class="nav-item">
              <a class="nav-link fw-medium p-3 rounded" routerLink="/login" (click)="closeMobileMenu()">
                <i class="fas fa-sign-in-alt me-1"></i>
                Login
              </a>
            </li>
          }
        </ul>
      </div>
    </div>
  </nav>
</header>
